// Types
import {
    DynamicObjectMappingType,
    ReferredClientTypes,
    DomainCdhCompanyMapping,
    CountryWiseLEConfig
} from "../../types/GeneralTypes";


export const INVITE_AFFILIATE: string = "inviteAffiliate";
export const CHOOSE_PASSWORD: string = "choosePassword";
export const CONFIRM_PASSWORD: string = "confirmPassword";
export const PARTNER_PORTAL_APPROVAL: string = "partnerPortalApproval";
export const CURRENCIES_DIRECT: string = "Currencies Direct";
export const CURRENCIES_DIRECT_SA: string = 'Currencies Direct SA';
export const TORFX: string = "TorFX";
export const FCG: string = "FCG";
export const CDLGB_URL: string = "https://www.currenciesdirect.com/en/info/privacy-policy";
export const CDLZA_URL: string = "https://www.currenciesdirect.com/en/info/privacy-policy";
export const CDINC_URL: string = "https://www.currenciesdirect.com/docs/cd_privacypolicy_usa.pdf";
export const TORGB_URL: string = "https://www.torfx.com/content/privacy.php";
export const TORAU_URL: string = "https://www.torfx.com.au/content/privacy.php";
export const FCGGB_URL: string = "https://www.foremostcurrencygroup.co.uk/privacy-policy";
export const APPROVE_PARTNER: string = "/approvePartner";
export const CD: string = 'CD';
export const CDSA: string = 'CDSA';
export const TORFX_OZ: string = 'TorFXOz';
export const USA: string = 'USA';
export const FOREMOST_CURRENCY_GROUP: string = "Foremost Currency Group";
export const BASIC_AUTH_TOKEN_CD: string = "bDc2N2Q0ZTJhOWFiOTc0NGQ5YTIyZmM0NzY0NzQwYzE5NDpiNzQwOWI5NDg1ZmM0NDEwOWZmNmNkM2NkY2UxMjYyOQ==";
export const BASIC_AUTH_TOKEN_CDSA: string = "bDcyMDEyMDNiYTVjOTk0NmE4OWViZmVjMmUyMWQ4MDU4YzoxN2ZiMjM3MTEwNGU0M2NmOTFjNzk4NDU1NmM1ZjI5MQ==";
export const BASIC_AUTH_TOKEN_TORFX: string = "bDc5ZDUyNGIxYzgwOTI0NzE0ODkzMTk2MTdkYThlMDYyNTowZjVmOWE0ODY5YTU0ZTJiODZmMjlhNDk4YjI3YTNlZQ==";
export const BASIC_AUTH_TOKEN_TORFXOZ: string = "bDcyMzdlODdkYmE5Yzg0ZTIyYjAwNWMwNzZiNzJmOGU0YTphOWRlN2M5ZDhjN2U0OGNiOWY2OWE2OGViZGNlYjZhYg==";
export const BASIC_AUTH_TOKEN_FCG: string = "bDdjNDgwZDVlMGZmNDA0YTRiOTQ1ODkzMDA2MDMwY2E2NzpkNTY3MTZjYzBiYjQ0ZjM1YWU3NjFmODU0NTk0NGE3Zg==";
export const MONTHS_DATA = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const MAX_YEAR = 2020;
export const MAX_MONTH_COUNT = 25;
export const GOOGLE_ANALYTICS_CONFIG_URL: string = 'https://www.googletagmanager.com/ns.html?id=GTM-WS9BH96';
export const GOOGLE_ANALYTICS_NON_PRODUCTION_CONFIG: string = 'GTM-WS9BH96';
export const GOOGLE_ANALYTICS_CONFIG = {
    'currenciesdirect': 'GTM-NFVL4ZS',
    'currenciesdirectsa': 'GTM-TMDGLJD',
    'torfx': 'GTM-MFZZLH3',
    'torfxoz': 'GTM-WFPTNPQ',
    'fcg': 'GTM-TS27QK9'
};
export const GOOGLE_ANALYTICS_HEADER_CONFIG_URL: string = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})(window,document,\'script\',\'dataLayer\',\'GTM-WS9BH96\');';
export const CLIENT_COUNTRY_CODE = {
    'United Kingdom': 'GBR',
    'France': 'FRA',
    'USA': 'USA',
    'South Africa': 'ZAF',
    'Spain': 'ESP',
    'Singapore': 'SGP',
    'Portugal': 'PRT',
    'New Zealand': 'NZL',
    'Korea Democratic Peoples Republic Of': 'PRK',
    'Japan': 'JPN',
    'Italy': 'ITA',
    'Ireland': 'IRL',
    'India': 'IND',
    'Germany': 'DEU',
    'Canada': 'CAN',
    'Australia': 'AUS',
    'South Korea': 'KOR'
};
export const AUTO_TIMEOUT_MODAL_OPEN_TIME = 1000 * 60 * 9;
export const AUTO_LOGOUT_TIME_AFTER_MODAL_OPEN = 1000 * 60 * 1;
export const ORGANIZATION_CODE_MAPPING = {
    cd: 'currenciesdirect',
    cdsa: 'cdsa',
    torfx: 'torfx',
    torfxoz: 'torfxoz',
    fcg: 'fcg',
};
export const PROD_ORGANIZATION_CODE_MAPPING = {
    currenciesdirect: 'currenciesdirect',
    currenciesdirectsa: 'currenciesdirectsa',
    torfx: 'torfx',
    torfxoz: 'torfxoz',
    foremostcurrencygroup: 'fcg',
};
export const ORGANIZATION_DOMAIN_SEND_REGISTRATION_LINK = {
    'cd': 'www.currenciesdirect.com/register',
    'cdsa': 'www.currenciesdirect.co.za/register',
    'torfx': 'pfxreg.torfx.com/register-page',
    'torfxoz': 'pfxreg.torfx.com.au/register-page',
    'fcg': 'www.foremostcurrencygroup.co.uk/register'
};
export const UNITED_KINGDOM_COUNTRY_CODE: string = 'UK';
export const GREAT_BRITAIN_COUNTRY_CODE: string = 'GBR';
export const UNITED_KINGDOM_ISD_CODE: string = '+44';
export const UNITED_KINGDOM_ISD_CODE_TEXT = { 'en': 'United Kingdom (+44)', 'pt': 'Reino Unido (+44)' };
export const ORGANIZATION__CODE_MAPPING = {
    'currenciesdirect': 'Currencies Direct',
    'currenciesdirectsa': 'CDSA',
    'torfx': 'TorFX',
    'torfxoz': 'TorFXOz',
    'fcg': 'FCG',
};
export const COMMISSIONS_NONE_VIEW: string = 'None';
export const COMMISSIONS_SUMMARY_VIEW: string = 'Summary';
export const COMMISSIONS_DETAILED_VIEW: string = 'Detailed';
export const XLSX_DOCUMENT_TYPE: string = 'xlsx';
export const PDF_DOCUMENT_TYPE: string = 'pdf';
export const DEFAULT_BREAKPOINT: number = 850;
export const DEFAULT_COMMISSIONS_BREAKPOINT: number = 840;
export const DEFAULT_COMMISSIONS_DETAILED_BREAKPOINT: number = 1200;
export const DEFAULT_COMMISSIONS_DETAILED_MED_BREAKPOINT: number = 960;
export const DEFAULT_REFERRALS_SEARCH_DETAILED_BREAKPOINT: number = 960;
export const REFERRAL_TYPE: string = 'referral';
export const REGISTRATION_TYPE: string = 'registration';
export const TRADES_TYPE: string = 'trades';
export const INVOICES: string = 'invoices';
export const NO_SEARCH_DATA_TYPE: string = 'noSearchData';
export const TAX_NUMBER_FIELD_NAME: string = 'taxNumber';
export const FILTER_OPTIONS = [
    { label: 'referrals.filters.referrals.label', value: REFERRAL_TYPE },
    { label: 'referrals.filters.registrations.label', value: REGISTRATION_TYPE },
    { label: 'referrals.filters.trades.label', value: TRADES_TYPE }
];
export const REFERRALS_SEARCH_RADIO_BTN_GRP_DETAILS = {
    name: 'searchFilter',
    options: [
        { key: 'referrals.search.table.radio.referralTrade', value: REFERRAL_TYPE },
        { key: 'referrals.search.table.radio.registrationTrade', value: REGISTRATION_TYPE }
    ]
};
export const COUNTRIES_ENABLE_FOR_MULTI_SELECT = [
    'AUS',
    'CAN',
    'FRA',
    'DEU',
    'IND',
    'IRL',
    'ITA',
    'JPN',
    'NZL',
    'PRT',
    'SGP',
    'ESP',
    'ZAF',
    'KOR',
    'KOR',
    'GBR',
    'USA'];
export const GRAPH_DEFAULT_COLOR = '#A57BDB';
export const ORGANIZATION_CURRENCY_MAPPING = {
    currenciesdirect: 'GBP',
    currenciesdirectsa: 'ZAR',
    torfx: 'GBP',
    torfxoz: 'AUD',
    fcg: 'GBP',
};
export const DEFAULT_BASE_CURRENCY = {
    CODE: 'GBP',
    SYMBOL: '£'
};
export const EMAIL_PREFERENCES_MAPPING: { [key: string]: string } = {
    'weekly_market_updates': 'weekly_market_updates',
    'promotions': 'promotions',
    'product_news': 'product_news',
    'newsletters': 'newsletters',
    'news_flash': 'news_flash',
    'daily_update': 'daily_update',
    'research_development': 'research_development'
};
export const ORGANIZATION_CODE_URL_MAPPING = {
    'CD': 'tracking-code',
    'CDSA': 'tracking-code-cdsa',
    'TorFX': 'tracking-code-torfx',
    'TorFXOz': 'tracking-code-torfxoz',
    'FCG': 'tracking-code-fcg',
};
export const AFFILIATES_TOTAL_GROUP_VALUE = 'all';
export const DISABLED_CURRENCY_FOR_DROPDOWN = {
    'CNH': 'CNH',
    'ZAL': 'ZAL',
    'RON': 'RON',
    'BRL': 'BRL'
};
export const TOTAL_COMMISSION_AMOUNT_PAID = 'TotalCommissionAmountPaid';
export const TOTAL_COMMISSION_PAID_CURRENCY = 'CommPaidCurrency';
export const TOTAL_COMMISSION_AMOUNT = 'TotalCommissionAmount';
export const TOTAL_COMMISSION_CURRENCY = 'TotalCommissionCurrency';
export const TIER_AMOUNT_CURRENCY = 'TierAmountCurrency';
export const TIER_AMOUNT_KEYS = [
    'FirstTierCommissionAmount',
    'SecondTierCommissionAmount',
    'ThirdTierCommissionAmount'];
export const DISABLED_COUNTRIES_IN_OPTION_LIST = [
    'SGP',
    'SYR',
    'RWA',
    'PRI',
    'ANT',
    'LBR',
    'LBN',
    'VAT',
    'ATF',
    'COM',
    'ALA',
    'UK'];
export const CD_REFERRING_VALUE = 'currenciesdirect';
export const CDSA_REFERRING_VALUE = 'currenciesdirectsa';
export const TORFX_REFERRING_VALUE = 'torfx';
export const TORFXOZ_REFERRING_VALUE = 'torfxoz';
export const FCG_REFERRING_VALUE = 'fcg';
export const DIALING_COUNTRY_CODE_ORG_MAPPING = {
    'CD': 'GBR',
    'Currencies Direct': 'GBR',
    'CDSA': 'ZAF',
    'TorFX': 'GBR',
    'TorFXOz': 'AUS',
    'FCG': 'GBR',
    'CDINC': 'USA',
    'CDLCA': 'USA',
    'CDLEU': 'ESP',
    'TOREU': 'GBR',
    'FCGEU': 'GBR'
};
export const DIALING_CODE_PRESENT_FOR_LE = [
    'CDINC',
    'CDLCA',
    'CDLEU',
    'TOREU',
    'FCGEU'];
export const BRANCH_NAME_MAPPING = {
    'currenciesdirect': 'Moorgate HO',
    'currenciesdirectsa': 'Cape Town',
    'torfx': 'Penzance',
    'torfxoz': 'GoldCoast',
    'fcg': 'Moorgate HO',
};
export const ORGANIZATION_CONTACT_NO_MAPPING = {
    'currenciesdirect': '+44 (0) 20 7847 9400',
    'currenciesdirectsa': '+27 (0) 21 418 0105',
    'torfx': '+44 (0) 1736 335 250',
    'torfxoz': '+61 (7) 5560 4480',
    'fcg': '+44 (0) 1442 892060',
};
export const USA_COUNTRY_LABEL = [
    'United States of America',
    'USA',
    'United States'];
export const CD_GB_LEGAL_ENTITY = 'CDLGB';
export const CD_ZA_LEGAL_ENTITY = 'CDLZA';
export const REMOVE_CATEGORIES_FOR_TOR = [
    'One pager',
    'Guide',
    'Flyer',
    'Poster',
    'Ebook'];
export const ACCOUNT_SECTION_ROUTE = '/account';
export const CD_USA_LEGAL_ENTITY = {
    'CDINC': 'CDINC',
    'CDLCA': 'CDLCA',
    'CDLGB': 'CDINC'
};
export const USA_LOCALE = 'en-us';
export const EU_LOCALE = 'en-eu';
export const DEFAULT_LOCALE = 'en';
export const REFERENCE_DATA_TRANSACTION_TYPE = 'transaction';
export const REFERENCE_DATA_ACCOUNT_SELECT_TYPE = 'accountSelect';
export const REFERENCE_DATA_ACCOUNT_SELECT_PROFILE_MANAGEMENT_TYPE = 'accountSelectProfileManagement';
export const REFERENCE_DATA_EMPLOYMENT_STATUS_TYPE = 'employmentStatus';
export const INVOICE_DOWNLOAD_LABEL = 'Download';
export const LEGAL_ENTITY = [
    'CDLGB',
    'CDLEU',
    'CDINC',
    'CDLCA',
    'CDLZA',
    'TOREU',
    'TORGB',
    'TORAU',
    'FCGEU',
    'FCGGB'
];
export const BRANDWISE_DISABLED_CURRENCIES = {
    'currenciesdirect': {
        'buyingCurrency': ['TRY', 'ROL', 'SKK', 'ZAL', 'CNH', 'NAD', 'GHS', 'MRY',
            'MWK', 'NGN', 'SCR', 'TZS'],
        'sellingCurrency': ['BHD', 'BBD', 'BGN', 'BWP', 'CNH', 'CNY', 'FJD',
            'HUF', 'INR', 'JOD', 'KES', 'KWD', 'LKR', 'MAD',
            'MXN', 'PHP', 'RON', 'TRY', 'TTD',
            'UGX', 'XCD', 'ROL', 'SKK', 'ZAL', 'NAD', 'GHS', 'MRY', 'MWK',
            'NGN', 'SCR', 'TZS', 'ZMW']
    },
    'currenciesdirectsa': {
        'buyingCurrency': ['ROL', 'SKK', 'ZAL', 'BHD', 'BBD', 'BGN', 'FJD',
            'INR', 'JOD', 'KWD', 'MAD', 'OMR', 'PHP', 'QAR', 'LKR', 'XCD',
            'CHF', 'TTD', 'RON', 'SAR', 'BRL'],
        'sellingCurrency': ['BHD', 'BBD', 'BGN', 'FJD', 'INR', 'JOD',
            'KWD', 'LKR', 'MAD', 'MWK', 'NGN', 'PHP', 'RON',
            'TTD', 'TZS', 'XCD', 'ROL', 'SKK', 'ZAL', 'ZMW', 'CHF', 'BRL']
    },
    'torfx': {
        'buyingCurrency': ['BHD', 'BBD', 'BGN', 'BWP', 'FJD', 'INR',
            'JOD', 'KES', 'KWD', 'LKR', 'MAD', 'MUR', 'OMR', 'PHP',
            'QAR', 'SAR', 'TTD', 'UGX', 'XCD', 'ROL', 'SKK', 'ZAL',
            'CNH', 'NAD', 'GHS', 'MRY', 'MWK', 'NGN', 'SCR', 'TZS', 'ZMW', 'BRL'],
        'sellingCurrency': ['BHD', 'BBD', 'BGN', 'BWP', 'CNH', 'CNY',
            'FJD', 'HUF', 'INR', 'JOD', 'KES', 'KWD', 'LKR',
            'MAD', 'MXN', 'PHP', 'RON',
            'TRY', 'TTD', 'UGX', 'XCD', 'ROL', 'SKK',
            'ZAL', 'NAD', 'GHS', 'MRY', 'MWK', 'NGN', 'SCR', 'TZS', 'ZMW', 'BRL']
    },
    'torfxoz': {
        'buyingCurrency': ['BHD', 'BBD', 'BGN', 'BWP', 'FJD', 'INR',
            'JOD', 'KES', 'KWD', 'LKR', 'MAD', 'MUR', 'OMR', 'PHP', 'QAR',
            'SAR', 'TTD', 'UGX', 'XCD', 'ROL', 'SKK', 'ZAL', 'CNH', 'NAD', 'GHS',
            'MRY', 'MWK', 'NGN', 'SCR', 'TZS', 'ZMW', 'BRL'],
        'sellingCurrency': ['BHD', 'BBD', 'BGN', 'BWP', 'CNH', 'CNY', 'FJD',
            'INR', 'JOD', 'KES', 'KWD', 'LKR', 'MAD', 'MXN',
            'PHP', 'RON', 'TRY', 'TTD', 'UGX', 'XCD',
            'ROL', 'SKK', 'ZAL', 'NAD', 'GHS', 'MRY', 'MWK', 'NGN', 'SCR',
            'TZS', 'ZMW', 'BRL']
    }
};
export const SELLING_CURRENCY_LABEL = 'sellingCurrency';
export const BUYING_CURRENCY_LABEL = 'buyingCurrency';
export const UPDATE_DETAILS_ERROR_CODES = {
    'INCORRECT_CURRENT_PASSWORD': '9999',
    'INCORRECT_NEW_PASSWORD': '2007',
};
export const DEFAULT_LANGUAGE = 'en';
export const EU_SPECIFIC_LEGAL_ENTITY = [
    'CDLEU',
    'TOREU',
    'FCGEU'
];

export const ACCESS_TOKEN_KEY: string = "access-token";
export const REFRESH_TOKEN_KEY: string = "refresh-token";

export const ALL_COMMISSION_PAID_TYPE = "All";
export const MANUAL_COMMISSION_PAID_TYPE = "Manual";
export const AUTO_COMMISSION_PAID_TYPE = "Automated";
export const WIDE_ENABLED_FIELDS = ['paid', 'profit'];
export const WRAPPED_TEXT_ENABLED_COLUMN = ['clientName', 'deal_no'];
export const COUNTRY_WISE_BANK_FIELDS_MAP = {
    'AUS': ['bsb_number', 'swift_code'],
    'NZL': ['bsb_number', 'swift_code'],
    'CAN': ['transit_number', 'swift_code'],
    'USA': ['aba_number', 'swift_code'],
    'ZAF': ['branch_code', 'swift_code'],
    'IND': ['ifsc_code', 'swift_code'],
    'CHN': ['cnaps_code', 'swift_code']
};
export const PFX = 'PFX';
export const CFX = 'CFX';
export const PARTNER = 'PARTNER';
export const RESOURCE_FILTER_MAPPING = {
    'Wealthmanagement': 'Wealth management',
    'Onlinemarketplace': 'Online marketplace selling',
};
export const REFERRED_CLIENT_TYPES: ReferredClientTypes = {
    'Private': 'Personal clients',
    'Business': 'Corporate clients',
    'Both': 'Personal clients;Corporate clients'
}
export const PARTNER_ID = 'partner_id';
export const REFERRAL_TYPE_GA4 = 'referral_type';
export const COUNTRY_WISE_LE_CONFIG: CountryWiseLEConfig = {
    'USA': {
        applicableLE: ['CDINC', 'CDLCA', 'CDLGB'],
        countryNamePossibilities: ['United States of America', 'USA', 'United States']
    },
    'CAN': {
        applicableLE: ['CDLCA'],
        countryNamePossibilities: ['Canada']
    },
    'ESP': {
        applicableLE: ['CDLEU'],
        countryNamePossibilities: ['ESP']
    }
}
export const REFERRAL_PARTNER_COOKIE = 'RefPartner';
export const REFERRED_AFFILIATE_JOURNEY = 'ReferredAffiliateJourney';
export const BECOME_PARTNER_JOURNEY = 'BecomePartnerJourney';
export const LEGAL_ENTITY_SHORT_HAND = {
    'CDLGB': 'GB',
    'CDLEU': 'EU',
    'CDINC': 'INC',
    'CDLCA': 'CA',
    'CDLZA': 'ZA',
    'TOREU': 'EU',
    'TORGB': 'GB',
    'TORAU': 'AU',
    'FCGEU': 'EU',
    'FCGGB': 'GB',
};

export const PORTUGUESE_LANGUAGE: string = 'pt';

export const LEGAL_ENTITY_CDH_COMPANY_MAPPING = {
    'CDLGB': 'currenciesdirect',
    'CDLEU': 'currenciesdirect',
    'CDINC': 'currenciesdirect',
    'CDLCA': 'currenciesdirect',
    'CDLZA': 'currenciesdirectsa',
    'TOREU': 'torfx',
    'TORGB': 'torfx',
    'TORAU': 'torfxoz'
};
export const SSO_CDH_COMPANY_KEY = 'cdhCompanyWithSSO';
export const DATE_ONLY_FORMAT: string = 'dd/mm/yyyy';
export const SKELETON_LOADER_ROWS_DUMMY_DATA = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }];
export const VBAN_DETAILS_CODE_COPY_NOTIF_TIMER = 1500;
export const PAGE_SIZE_OPTIONS: number[] = [5, 10];
export const DATA_GRID_ROW_DEFAULT_HEIGHT: number = 64;
export const FIRPTA_CATEGORY: string = 'FIRPTA';
export const CLIENT_BANK_DETAILS_CSV_FILE_NAME: string = 'Client_Bank_Details';
export const CDH_COMPANY_ORG_CODE_MAPPING = {
    currenciesdirect: 'CD',
    currenciesdirectsa: 'CDSA',
    torfx: 'TorFX',
    torfxoz: 'TorFXOz'
};
export const BAP_CUSTOMER_TYPE_SWITCH_OPTIONS = [
    { key: 'become.partner.form.customertype.individual', value: 'PFX' },
    { key: 'become.partner.form.customertype.company', value: 'CFX' }
];
export const BAP_ADD_TAX_COUNTRIES = ['PRT', 'ESP'];
export const ORG_CODE_MAPPING_FOR_LOCATION_LOOKUP = {
    [CURRENCIES_DIRECT]: CD,
    [CDSA]: CDSA,
    [TORFX]: TORFX,
    [TORFX_OZ]: TORFX_OZ,
};
export const COUNTRY_WISE_BANK_DETAILS_FIELDS = [
    { type: 'accountNumber', values: ["AUS", "NZL", "CAN", "USA", "ZAF", "IND", "CHN"], payloadKeyName: 'account_number' },
    { type: 'bsbNumber', values: ["AUS", "NZL"], payloadKeyName: 'bsb_number' },
    { type: 'swiftCode', values: ["AUS", "NZL", "CAN", "USA", "ZAF", "IND", "CHN", "QAT", "BGR", "GGY", "JEY"], payloadKeyName: 'swift_code' },
    { type: 'transitNumber', values: ["CAN"], payloadKeyName: 'transit_number' },
    { type: 'abaNumber', values: ["USA"], payloadKeyName: 'aba_number' },
    { type: 'branchCode', values: ["ZAF"], payloadKeyName: 'branch_code' },
    { type: 'ifscCode', values: ["IND"], payloadKeyName: 'ifsc_code' },
    { type: 'iban', values: ["AND", "AUT", "BH", "BEL", "HRV", "CYP", "CZE", "DNK", "EST", "FIN", "FRA", "GIB", "DEU", "GRC", "HUN", "ISL", "IRL", "ISR", "ITA", "KWT", "LVA", "LTU", "LIE", "LUX", "MLT", "MCO", "MNE", "NLD", "NOR", "POL", "PRT", "ROU", "SAU", "SVK", "SWE", "ESP", "CHE", "TUN", "TUR", "ARE", "GBR", "QAT", "BGR", "GGY", "JEY"], payloadKeyName: 'iban' },
    { type: 'cnapsCode', values: ["CHN"], payloadKeyName: 'cnaps_code' }
];
export const BANK_LOCAL_CODE_TYPE_COUNTRY_MAPPING = { "GBR": "SORT", "AUS": "BSB", "NZL": "BSB", "CAN": "Transit", "USA": "ABA", "IND": "IFSC", "CHN": "CNAPS", "RUS": "BIK" };
export const BANK_LOCAL_CODE_TYPE_COUNTRY_DEFAULT_CODE: string = "BRANCH";
export const THIRD_PARTY_AUTHENTICATION_ROUTE = '/keycloack_auth';
export const PARTNER_APPROVAL_SIGN_TS_AND_CS_TYPE: string = 'signTsAndCs';
export const MASK_CLASS = 'cx-mask';
export const REDACT_CLASS = 'cx-redact';
export const BRAND_WISE_CDHCOMPANY_VALUE = {
    currenciesdirect: 'currenciesdirect',
    torfx: 'torfx',
    torfxau: 'torfxoz',
    cdsapartner: 'currenciesdirectsa',
};
export const STATEMENT_DOWNLOAD_VALIDATION_DATE: string = '2023-1-1';
export const DATE_MONTH_DATE_YEAR_FORMAT: string = 'dd-MMM-yyyy';
export const MIME_FILE_TYPES_EXTENSIONS: DynamicObjectMappingType = {
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf',
    txt: 'text/plain',
    webp: 'image/webp',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip'
};
export const ZIP_MIME_TYPE: string = 'application/zip';

export const FILE_EXTENSION_VALIDATION_OPTIONS: string[] = ['pdf', 'jpeg', 'png', 'jpg'];

export const DOMAIN_COMPANY_MAP: DomainCdhCompanyMapping = {
    SIT: {
        'partner.sit.currenciesdirect.com': 'currenciesdirect',
        'partner.sit.torfx.com.au': 'torfxoz',
        'partner.sit.torfx.com': 'torfx',
        'cdsapartner.sit.currenciesdirect.com': 'currenciesdirectsa',
    },
    UAT: {
        'partner.uat.currenciesdirect.com': 'currenciesdirect',
        'partner.uat.torfx.com.au': 'torfxoz',
        'partner.uat.torfx.com': 'torfx',
        'cdsapartner.uat.currenciesdirect.com': 'currenciesdirectsa',
    },
    PROD: {
        'partner.currenciesdirect.com': 'currenciesdirect',
        'partner.torfx.com.au': 'torfxoz',
        'partner.torfx.com': 'torfx',
        'cdsapartner.currenciesdirect.com': 'currenciesdirectsa',
    },
};

export const WEBLEADS_V5_API_SUCCESS_CODE: string = '000';

export const PASSWORD_POLICY_ERROR_CODE: string = 'ER-4006';

export const MARKETING_BUSINESS_CATEGORIES: string[] = ['Marketing Affiliate - Cost Per Lead', 'Marketing Affiliate - Hybrid', 'Marketing Affiliate - Rev-Share'];

export const AFFILIATE_TERMS_URLS: Record<string, any> = {
    CD: {
        default: 'https://www.currenciesdirect.com/en-gb/affiliate-terms-and-conditions',
        EU_EEA: 'https://www.currenciesdirect.com/en-gb/affiliate-terms-and-conditions-eu',
        USA: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
        CAN: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
        LATAM: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
    },
    CDSA: {
        default: 'https://www.currenciesdirect.com/en-gb/affiliate-terms-and-conditions',
        EU_EEA: 'https://www.currenciesdirect.com/en-gb/affiliate-terms-and-conditions-eu',
        USA: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
        CAN: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
        LATAM: 'https://www.currenciesdirect.com/en-gb/partner-terms-and-conditions-usa',
    },
    TorFX: {
        default: 'https://www.torfx.com/partners/affiliate-terms-and-conditions.php',
        EU_EEA: 'https://www.torfx.com/partners/affiliate-terms-and-conditions-eu.php',
        AUS: 'https://www.torfx.com.au/partners/affiliate-terms-and-conditions.php',
        NZL: 'https://www.torfx.com.au/partners/affiliate-terms-and-conditions.php'
    },
    TorFXOz: {
        default: 'https://www.torfx.com.au/partners/affiliate-terms-and-conditions.php',
        EU_EEA: 'https://www.torfx.com/partners/affiliate-terms-and-conditions-eu.php',
        ASIA: 'https://www.torfx.com/partners/affiliate-terms-and-conditions.php',
        AFRICA: 'https://www.torfx.com/partners/affiliate-terms-and-conditions.php',
        AUS: 'https://www.torfx.com.au/partners/affiliate-terms-and-conditions.php',
        NZL: 'https://www.torfx.com.au/partners/affiliate-terms-and-conditions.php',
        UK: 'https://www.torfx.com/partners/affiliate-terms-and-conditions.php'
    }
};

export const OUT_BANK_DETAILS_DEFAULT_LEGAL_ENTITY = 'CDLEU';

export const LEGAL_ENTITY_OPTIONS = [
    { label: 'Currencies Direct Spain', value: 'CDLEU' },
    { label: 'Currencies Direct Limited', value: 'CDLGB' }
];